import React from "react";
import Modal from "react-bootstrap/Modal";
import FailedImg from "../../../../../../../../assets/images/failed.png";
import "./index.css";

const PaymentFailedModal = ({ showPaymentF, handleClosePaymentF }) => {
  return (
    <div>
      <Modal
        show={showPaymentF}
        onHide={() => {
          handleClosePaymentF();
          window.location.reload();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-left ml-3">
            <div className="mb-2">
              <div className="text-center mt-3 mb-5">
                <div className="successImg mb-4">
                  <img src={FailedImg} alt="success image" />
                </div>
                <div>
                  <p>Transaction Failed</p>
                  <p style={{ fontSize: "12px" }}>Something went wrong</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PaymentFailedModal;
